import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import useReorderChapters from "./useReorderChapters";

export default function useChapters(){

    const {id} = useParams()

    const reorderChapters = useReorderChapters()

    return useQuery({

        queryKey: ['design', id, 'chapters'],

        queryFn: () => API.get(`/design/courses/${id}/chapters`)
            .then(r => reorderChapters(r.data)),

        staleTime: 'Infinity',
        refetchInterval: false,
        refetchIntervalInBackground: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
    })
};